module.exports = __webpack_public_path__ + "bed19f25871e99b367543ff116e653ad.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/medium/public/games/dow_image_3.png
// module id = 499
// module chunks = 0